var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative min-h-screen",attrs:{"id":"app"}},[(_vm.$store.state.loadingApplication)?_c('div',{staticClass:"absolute inset-0 z-50 p-16"},[_c('v-spa-loader'),_vm._v(" "),_c('p',{staticClass:"font-thin text-center text-gray-700"},[_vm._v("Loading application...")])],1):_vm._e(),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }